// Shared role/permission helpers for the Project Management task module.
//
// Role model (see hr_staff_basic_infos):
//   - user_type === "admin"      -> full access (the seeded "Super Admin" account)
//   - department_head === 1      -> department head, also full access
//   - everyone else              -> normal member (restricted)
//
// A "privileged" user (admin or head) can view/edit/copy/delete every task and
// see the calendars. A normal member sees mainly their own tasks and can only
// change the status of a task they are assigned to.

export const isPrivilegedUser = (user) =>
  !!user &&
  (user.user_type === "admin" || Number(user.department_head) === 1);

// True when the given user is one of the developers assigned to the task.
export const isOwnTask = (task, userId) =>
  Array.isArray(task?.developers) &&
  task.developers.some((dev) => dev.id === userId);

// The API serialises the `createdBy` relation under the key `created_by`, which
// shadows the raw column — so this field arrives as { id, name } when the
// relation was eager-loaded and as a plain id when it wasn't. Both are handled.
export const getTaskCreator = (task) => {
  const raw = task?.created_by;
  if (raw && typeof raw === "object") {
    return { id: raw.id ?? null, name: raw.name || null };
  }
  return { id: raw ?? null, name: null };
};

// Members may create tasks and afterwards edit the ones they created.
// Deleting stays with admins and department heads. Mirrors TaskController.
export const isTaskCreator = (task, userId) => {
  const { id } = getTaskCreator(task);
  return id != null && userId != null && Number(id) === Number(userId);
};

export const canEditTask = (task, user) =>
  isPrivilegedUser(user) || isTaskCreator(task, user?.id);

export const canDeleteTask = (_task, user) => isPrivilegedUser(user);
